<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Seite bearbeiten') }}</h1>
            <div>
                <a :href="page.permalink" target="_blank">
                    {{ page.permalink }}
                </a>
            </div>
        </div>

        <div class="">
            <form @submit.prevent="form.put(route('admin.pages.update', page))">
                <form-fields 
                    :form="form" 
                    :page="page" 
                    :template-options="templateOptions" 
                    :publish-status-options="publishStatusOptions" 
                    />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'page',
            'templateOptions',
            'publishStatusOptions',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    account_id: this.page.account_id,
                    title: this.page.title,
                    slug: this.page.slug,
                    content: this.page.content,
                    meta_title: this.page.meta_title,
                    meta_description: this.page.meta_description,
                    meta_robots: this.page.meta_robots,
                    image_id: this.page.image_id,
                    template: this.page.template,
                    number_views: this.page.number_views,
                    publish_status: this.page.publish_status,
                    publish_from: this.page.publish_from ? moment(this.page.publish_from).format('YYYY-MM-DDTHH:mm') : null,
                    publish_until: this.page.publish_until ? moment(this.page.publish_until).format('YYYY-MM-DDTHH:mm') : null,
//                    visible_to_logged_in_users_only: this.page.visible_to_logged_in_users_only,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>